import React, {useEffect} from 'react';
import './Fidelius.scss';
import {Router} from "@reach/router";
import VaultEdit from "../VaultCreate/VaultEdit";
import VaultCreate from "../VaultCreate/VaultCreate";
import Login from "../Login/Login";
import PrivateRoute from "../../utils/ProtectedRoute";
import NavBar from "../NavBar/NavBar";
import {compose} from "redux";
import {connect} from "react-redux";
import CircularProgress from "@material-ui/core/CircularProgress";
import {useAuth0} from "../../utils/providers/Auth0Provider";
import {updateToken, updateUser} from "../../redux/reducers/user";
import Dashboard from "../Dashboard/Dashboard";
import {Helmet} from 'react-helmet';
import EmailConfirmation from "../EmailConfirmation/EmailConfirmation";
import Vault from "../Vault/Vault";
import ConfirmationModal from "./ConfirmationModal";
import {ScrollToTop} from "./ScrollToTop";
import UnknownError from "../UnknownError/UnknownError";
import ReactGA from 'react-ga';
import Signup from "../Signup/Signup";
import routes from "../../utils/api-client";
import * as _ from "lodash";
import ActivityLogItem from "../Dashboard/ActivityLog/ActivityLogItem";
import ActivityLogModal from "../Dashboard/ActivityLog/ActivityLogModal";
import Paper from "@material-ui/core/Paper";
import ClientDashboard from "../ClientDashboard/ClientDashboard";
import Client from "../Client/Client";
import ClientVaultCreate from "../ClientVaultCreate/ClientVaultCreate";


function Fidelius(props) {
  const { user, getTokenSilently } = useAuth0();

  useEffect(() => {
    if (user) {
      props.updateToken(getTokenSilently());
    }
  }, [user]);

  useEffect(() => {
    if (props.token) {
      routes.getUser().subscribe((response) => {
        props.updateUser(user, response.data);
      });
    }
  }, [props.token]);

  useEffect(() => {
    ReactGA.initialize('UA-168015356-1');
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Fidelius Vaults</title>
      </Helmet>

      <div className={`absolute flex items-center center-xs full-size loading-container-nav-background ${props.loading ? '' : 'hidden no-pointer-events'}`}/>
      <div className={`absolute flex items-center center-xs full-size loading-container-progress ${props.loading ? '' : 'hidden no-pointer-events'}`}>
        <div>
          <CircularProgress size={100} thickness={5} color="primary"/>
        </div>
      </div>
      <NavBar/>
      <div className="application-container relative">
        <div className={`absolute flex items-center justify-center full-size loading-container-background ${props.loading ? '' : 'hidden no-pointer-events'}`}/>

        <div className="background-container"/>
        <Router className="flex flex-1 overflow-auto route-container" primary={false}>
          <ScrollToTop path="/">
            <UnknownError path={"unknown-error"}/>
            <Login path="login"/>
            <Signup path="signup"/>
            <Vault path="vaults/:vaultId/access/:accessRequestCode"/>
            <PrivateRoute component={Dashboard} path={"vaults"} default/>
            {/*<PrivateRoute component={ClientVaultCreate} path={"clients/:clientId/create-vault"}/>*/}
            {/*<PrivateRoute component={ClientDashboard} path={"clients"}/>*/}
            {/*<PrivateRoute component={Client} path={"clients/:clientId"}/>*/}
            <PrivateRoute component={Vault} path={"vaults/:vaultId"}/>
            <PrivateRoute component={VaultEdit} path={"vaults/:vaultId/edit"}/>
            <PrivateRoute component={VaultCreate} path={"vaults/create"}/>
            <PrivateRoute component={EmailConfirmation} path={"email-confirmation"}/>
          </ScrollToTop>
        </Router>
      </div>

      <ConfirmationModal/>

    </React.Fragment>
  );
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    loading: state.utils.loading,
    token: state.user.token,
    user: state.user.user,
  };
};


export default compose(
  connect(mapStateToProps, {updateUser, updateToken})
)(Fidelius);
